// Feature: stop/suspension, scope change, PH cancellation, RS closeout, archive status
// (owner: closeout work package).
// Contract: export closeoutActionPanels, CloseoutView.
import type { ActionPanelMap } from '@/features/contracts'
import { CloseoutPanel } from './panels/CloseoutPanel'
import { ConfirmSuspensionPanel } from './panels/ConfirmSuspensionPanel'
import { PhCancellationPanel } from './panels/PhCancellationPanel'
import { ReportSuspensionPanel } from './panels/ReportSuspensionPanel'
import { ScopeChangePanel } from './panels/ScopeChangePanel'

export { CloseoutView } from './CloseoutView'

export const closeoutActionPanels: ActionPanelMap = {
  report_suspension: ReportSuspensionPanel,
  confirm_suspension: ConfirmSuspensionPanel,
  request_scope_change: ScopeChangePanel,
  sign_ph_cancellation: PhCancellationPanel,
  close_out_permit: CloseoutPanel,
}
